const mutations = {
    SET_LIVES (state, payload) {
        state.lives = payload
    },
    SET_WORKOUTS (state, payload) {
        state.workouts = payload
    },
    SET_ACTIVEWORKOUT (state, payload) {
        state.activeWorkout = payload
    },
    SET_ACTIVEVIDEO (state, payload) {
        state.activeVideo = payload
    },
    SET_BANNERS (state, payload) {
        state.banners = payload
    },
    SET_LOCALE (state, payload) {
        state.locale = payload
    },
    SET_THEME (state, payload) {
        state.theme = payload
    },
    SET_KITS (state, payload) {
        state.kits = payload
    },
    SET_ACTIVEKIT (state, payload) {
        state.activeKit = payload
    },
    SET_LAYOUTPARTS (state, payload) {
        state.layoutParts = payload
    },
    SET_VIDEOS (state, payload) {
        state.videos = payload
    }
}

export default mutations
